import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Selector, SelectorCreate } from "@/model";
import selectorRepository from "@/repository/selectorRepository";
import { selectorQueryKeys } from "./keys";


export const useCreateSelector = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Selector, AxiosError, SelectorCreate>({
        mutationKey: ["selector", "agent", agentId, "create"],
        mutationFn: async (body: SelectorCreate) => {
            try {
                const { data } = await selectorRepository.create(agentId, body);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: selectorQueryKeys.pageAll(agentId),
                exact: false
            });
        }
    });
};
